import { render, staticRenderFns } from "./StokEslestirButon.vue?vue&type=template&id=131c7395"
import script from "./StokEslestirButon.vue?vue&type=script&lang=js"
export * from "./StokEslestirButon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports